import { useState } from 'react';

export const useSearchedStatus = () => {
  const [isSearchIncorrect, setSearchedStatus] = useState<boolean>(true);

  return {
    isSearchIncorrect,
    setSearchedStatus,
  };
};
